/* eslint-disable camelcase */
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MultiSelectComponent from "./MultiSelectComponent";
import DropdownTreeSelect from "react-dropdown-tree-select";
import "./dropDownTreeSelect.scss";
import "react-dropdown-tree-select/dist/styles.css";
import InfoCard from "./InfoCard";

import React from "react";


export enum validationMode {
  "none",
  "classic",
  "invalid",
}

export const validationClass = (errors: any, isValid: any) => {
  if (errors) {
    return "is-invalid";
  } else if (isValid) {
    return "is-valid";
  } else {
    return "";
  }
};

export function isInvalidClass(errors: any) {
  return errors && "is-invalid";
}

const CpntFormFieldGroup: React.FC<any> = ({
  type,
  label,
  sublabel,
  register,
  name,
  errors,
  defaultValue,
  dataSelect,
  disabled,
  onchange,
  popover,
  popoverPlacement,
  defaultSelect,
  selected: selectedParam,
  multiselect_limit,
  step,
  nullValue,
  ismandatory,
  currentlength,
  maxlength,
  value,
  minDate,
  maxDate,
  isValid,
  autoFocus,
  accept,
  onClick,
  placeholder,
}: any) => {
  let error = "";
  error += !type ? "type " : "";
  error += !name ? "name " : "";
  error = error !== "" ? "this parameters are required : " + error : "";

  if (error !== "") {
    return <div>{error}</div>;
  } else {
    return (
      <>
        {popover ? (
          <div className="pae-label-with-popover">
            {label && (
              <label htmlFor={name} className="form-label">
                {label} {ismandatory && <em className="text-danger">*</em>}
              </label>
            )}
            <InfoCard content={popover} placement={popoverPlacement} />
          </div>
        ) : (
          label && (
            <label htmlFor={name} className="form-label">
              {label} {ismandatory && <em className="text-danger">*</em>}
            </label>
          )
        )}
        {(type === "text" || type === "password") && (
          <input
            type={type}
            autoFocus={autoFocus}
            id={name}
            disabled={disabled}
            {...register(name)}
            value={value}
            defaultValue={defaultValue}
            className={`form-control ${validationClass(errors, isValid)}`}
            onChange={(e) => {
              if (onchange) {
                onchange(e.target.value, e.target.name);
              }
            }}
            placeholder={placeholder}
          />
        )}

        {type === "number" && (
          <input
            type={type}
            id={name}
            //presicion={2}
            min="0"
            step={step}
            disabled={disabled}
            {...register(name)}
            value={defaultValue}
            className={`form-control ${validationClass(errors, isValid)}`}
            onChange={(e) => {
              if (onchange) {
                onchange(e.target.value, e.target.name);
              }
            }}
          />
        )}
        {type === "textarea" && (
          <textarea
            {...register(name)}
            defaultValue={defaultValue}
            className={`form-control ${validationClass(errors, isValid)}`}
            onChange={(e) => {
              if (onchange) {
                if (maxlength) {
                  onchange(
                    e.target.value.substring(0, maxlength),
                    e.target.name
                  );
                } else {
                  onchange(e.target.value, e.target.name);
                }
              }
            }}
            maxLength={maxlength}
            placeholder={placeholder}
          />
        )}

        {type === "select" && (
          <select
            className={`form-select ${validationClass(errors, isValid)}`}
            {...register(name)}
            value={value}
            disabled={disabled}
            onChange={(e) => {
              if (onchange) {
                onchange(e.target.value, e.target.name);
              }
            }}
          >
            {nullValue && (
              <option
                key={0 + "_" + dataSelect?.Id}
                value={0}
                className="pae-detail-label"
              >
                {nullValue}
              </option>
            )}
            {dataSelect?.map((item: { Id: string | number | readonly string[] | undefined; Libelle: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; }, i: string) => {
              return (
                <option key={i + "_" + item.Id} value={item.Id}>
                  {item.Libelle}
                </option>
              );
            })}
          </select>
        )}
        {type === "multi-select" && (
          <MultiSelectComponent
            options={dataSelect}
            id={name}
            value={value}
            {...register(name)}
            limitSelection={multiselect_limit}
            className={`form-control ${validationClass(errors, isValid)}`}
            setSelected={(value) => onchange(value)}
          />
        )}
        {type === "tree-select" && (
          <DropdownTreeSelect
            data={dataSelect}
            onChange={(value) => {
              if (onchange) {
                onchange(value);
              }
            }}
            mode="radioSelect"
            className={`dropdown-form ${errors && "invalid"} ${
              isValid && "valid"
            }`}
            keepTreeOnSearch={true}
            texts={{ placeholder: defaultSelect || "-" }}
          />
        )}
        {type === "fileupload" && (
          <input
            {...register(name)}
            id={name}
            className={`form-control ${validationClass(errors, isValid)}`}
            type="file"
            accept={accept}
            onChange={(e) => {
              if (onchange) {
                const file = (e?.target as HTMLInputElement)?.files?.[0];
    if (file) {
      onchange(file);
    }
               
              }
            }}
            onClick={() => {
              if (onClick) {
                onClick();
              }
            }}
          />
        )}
        {type === "date" && (
          <DatePicker
            placeholderText="Sélectionner une date"
            className={`form-control ${validationClass(errors, isValid)}`}
            selected={selectedParam}
            {...register(name)}
            id={name}
            dateFormat="dd/MM/yyyy"
            minDate={minDate}
            maxDate={maxDate}
            locale="fr"
            autoComplete="off"
            onChange={(e) => {
              if (onchange) {
                onchange(e);
              }
            }}
          />
        )}
        {type === "checkbox" && (
          <div className="pae-form-section">
            {sublabel}
            {!label && ismandatory && <em className="text-danger">*</em>}
            {dataSelect.map((option: { name: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined; value: string | number | readonly string[] | undefined; defaultChecked: any; }, key: string) => (
              <div
                className="form-check form-check-inline"
                key={key + "_" + option.name}
              >
                <input
                  {...register(name)}
                  className={`form-check-input ${isInvalidClass(errors)}`}
                  id={key + "_" + option.name}
                  type={type}
                  value={option.value}
                  defaultChecked={
                    option.defaultChecked && option.defaultChecked
                  }
                  onChange={(e) => {
                    if (onchange) {
                      onchange(e.target.checked);
                    }
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor={key + "_" + option.name}
                >
                  {option.name}
                </label>
              </div>
            ))}
          </div>
        )}
        {(type === "checkboxList" || type === "radio") && (
          <div className="pae-form-section pae-inline-inputs">
            {sublabel}
            {!label && ismandatory && <em className="text-danger">*</em>}
            {dataSelect.map((option: { name: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined; value: string | number | readonly string[] | undefined; defaultChecked: any; }, key: string) => (
              <div
                className="form-check form-check-inline"
                key={key + "_" + name}
              >
                <input
                  className={`form-check-input ${isInvalidClass(errors)}`}
                  id={key + "_" + option.name}
                  {...register(name)}
                  type={type}
                  value={option.value}
                  defaultChecked={option.defaultChecked === option.value}
                  onChange={() => {
                    if (onchange) {
                      onchange(option.value);
                    }
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor={key + "_" + option.name}
                >
                  &nbsp;{option.name}
                </label>
              </div>
            ))}
          </div>
        )}
        {errors && (
          <div className="invalid-feedback d-flex justify-content-start display-linebreak">
            {errors?.replace(/\\n/g, "\n")}
          </div>
        )}
        {maxlength && (
          <div className="d-flex justify-content-end">
            {
              <em>
                Nombre de caractères restants : {maxlength - (currentlength || 0)}
              </em>
            }
          </div>
        )}
      </>
    );
  }
};

export default CpntFormFieldGroup;
